<!--
 * @Author: pfy
 * @LastEditors: pfy
 * @Date: 2019-09-09 15:23:14
 * @LastEditTime: 2019-09-16 19:56:40
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 -->
<!-- 价格指数 -->
<template>
  <div class="price">
    <div class="price-echart-header">价格指数</div>
    <!--单位规格-->
    <p class="price-echart-header-type" />
    <!-- 图表 -->
    <div id="myChart" ref="myChart" :style="{width: '800px', height: '350px'}" />
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/home/home.js' // 请求接口
export default {
  // props:{
  //
  // }
  data() {
    return {
      // 价格指数图表
      priceChartData: {}
    }
  },
  created() {
    // 价格指数（图表）
    get.priceIndex().then(res => {
      this.priceChartData = res.result
      // 图表相关
      this.drawLine()
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {
    // 价格指数图表
    // 线性图表
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(this.$refs.myChart)
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ['水路', '公路', '管道', '铁路']
        },
        tooltip: {
          trigger: 'item',
          // show: true
          // alwaysShowContent: false,
          // axisPointer: { // 坐标轴指示器，坐标轴触发有效
          //   type: 'none' // 默认为直线，可选为：'line' | 'shadow'
          // },
          // formatter: '{a} <br/>{b} : {c}<br/>'
          formatter: function(val) {
            // console.log(val)
            return `价格：${val.data.price}元<br/>价格指数：${val.data.priceIndex}<br/>涨跌值：${val.data.indexValues}元<br/>涨跌幅：${val.data.indexPercent}%`
          }
        },
        grid: {
          x: '0', // 左上角x轴距盒子边框的距离
          y: 40, // 左上角Y轴距盒子边框的距离
          x2: '0' // 右下角x轴距盒子边框的距离
          // y2: 0 // 右下角Y轴距盒子边框的距离
          // borderWidth: 1
        },
        xAxis: {
          data: this.priceChartData.date, // 时间
          // data: ['2018','2019'],
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          'axisLabel': {
            'interval': 0
          }
        },
        yAxis: {
          type: 'value',
          show: false
        },
        series: [
          {
            type: 'line',
            name: '水路',
            showAllSymbol: true,
            smooth: true,
            itemStyle: { normal: { label: { show: true }}},
            data: this.priceChartData.type3
          },
          {
            type: 'line',
            name: '公路',
            showAllSymbol: true,
            smooth: true,
            itemStyle: { normal: { label: { show: true }}},
            data: this.priceChartData.type1
          },
          {
            type: 'line',
            name: '管道',
            showAllSymbol: true,
            smooth: true,
            itemStyle: { normal: { label: { show: true }}},
            data: this.priceChartData.type4
          },
          {
            type: 'line',
            name: '铁路',
            showAllSymbol: true,
            smooth: true,
            itemStyle: { normal: { label: { show: true }}},
            data: this.priceChartData.type2
            // data: [
            //   { name: 1, value: '35', odata: '666' },
            //   { name: 2, value: '0', odata: '777' },
            //   { name: 3, value: '50', odata: '888' },
            //   { name: 4, value: '60', odata: '999' }
            // ]
          }]
      })
    }
  }
}
</script>
<style scoped lang='scss'>
  /*价格指数*/
  .price{
    width: 100%;
    height: 400px;
    border-bottom: 2px solid #DCDCDC;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .price-echart-header{
      position: relative;
      width: 100%;
      height: 40px;
      font-size: 40px;
      color: #060606;
      text-indent: 20px;
      margin-bottom: 15px;
      &:before{
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        left: 0;
        top: 12px;
        border-bottom: 8px solid transparent;
        border-top: 8px solid transparent;
        border-left: 8px solid #BE2316;
      }
    }
    .price-echart-header-type{
      color: #555555;
      font-size: 14px;
      padding-left: 24px;
    }

    .price-item{
      width: 450px;
      height: 360px;
      float: left;
      padding: 0 0 0 15px;
      border-left: 2px solid #DCDCDC;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      .price-item-header{
        position: relative;
        width: 100%;
        height: 36px;
        font-size: 30px;
        color: #060606;
        text-indent: 20px;
        &:before{
          position: absolute;
          content: '';
          width: 0;
          height: 0;
          left: 0;
          top: 6px;
          border-bottom: 8px solid transparent;
          border-top: 8px solid transparent;
          border-left: 8px solid #BE2316;
        }
      }
      .item-wrap{
        position: relative;
        width: 100%;
        height: 320px;
        margin-top: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        overflow: hidden;
        .nwwest-roll {
          width: 100%;
          height: 320px;
          overflow: hidden;
          transition: all 0.5s;
        }
        .nwwest-roll li{
          width: 100%;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px dashed #d0d0d0;
          font-size: 14px;
          .item-sp{
            font-size: 14px;
            display: inline-block;
            color: #555555;
            &:nth-child(1){
              width: 29%;
            }
            &:nth-child(2){
              width: 29%;
            }
            &:nth-child(3){
              width: 19%;
            }
            &:nth-child(4){
              width: 19%;
              text-align: right;
              color: #419911;
            }
          }
        }
        .anim{
          transition: all 0.5s;
        }
      }
    }
  }
</style>
